/**
 * Single source of truth for TeachPartner branding and app identifiers.
 * Environment-specific values (hosts, EAS project) live in .env files and
 * app.config.ts; this module holds only values that are the same everywhere.
 */
export const BRAND = {
  displayName: 'TeachPartner',
  shortName: 'TeachPartner',
  /** Lowercase prefix for code identifiers, realms, clients and images. */
  codePrefix: 'teachpartner',
  appScheme: 'teachpartner',
  iosBundleId: 'ai.mantleai.teachpartner',
  androidPackage: 'ai.mantleai.teachpartner',
  publisher: 'Mantle International',
} as const;

export const KEYCLOAK = {
  tenantRealm: `${BRAND.codePrefix}`,
  hostRealm: `${BRAND.codePrefix}-host`,
  appClientId: `${BRAND.codePrefix}-app`,
  tenantApiClientId: `${BRAND.codePrefix}-tenant-api`,
  /**
   * Scopes the app requests. Every one except "openid" must be a default or optional client
   * scope of the app client in src/keycloak/realm/teachpartner-realm.json, or Keycloak rejects
   * the sign-in with "Invalid scopes" (bug 2026-10-07; guarded by a mobile test).
   */
  appScopes: ['openid', 'profile', 'email', 'offline_access'],
} as const;

/** OAuth redirect path shared by native (scheme) and web (WEB_APP_HOST). */
export const AUTH_CALLBACK_PATH = 'auth/callback';

export type Brand = typeof BRAND;
